import { Tooltip } from '@ipfabric/ui-components/Tooltip/Tooltip';
import type { FC } from 'react';

const CALCULATED_TOOLTIP =
  'All path-lookups for this flow have been calculated.';

/**
 * The settled half of the Flows `Calculation status` cell: plain text, but
 * tooltipped so it reads as a deliberate end state rather than a bare word.
 *
 * The other half is `AimCalculateDevicesLink` — the cell shows one or the other,
 * never both.
 */
export const AimCalculatedLabel: FC = () => (
  <Tooltip content={CALCULATED_TOOLTIP}>
    {/* Tooltip attaches its hover handlers by cloning this child, so the text
        needs an element of its own to hang them on. */}
    <span>Calculated</span>
  </Tooltip>
);
